// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 320px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "(max-width: 1024px)";
var _5 = "mainWrapper-3sccr";
var _6 = "wrapper-3J8UZ";
var _7 = "wrapperOpacity-3wr1G";
var _8 = "wrapper_closed-3ornf";
var _9 = "wrapperOff-3ERAf";
var _a = "container-3btIB";
var _b = "header-3IZmG";
var _c = "modal_title-21HCP";
var _d = "close-3jXJk";
var _e = "container_noPadding-2TemQ";
var _f = "container_scrollable-1VtOp";
export { _1 as "__esModule", _2 as "iphone5", _3 as "mobile", _4 as "tablet", _5 as "mainWrapper", _6 as "wrapper", _7 as "wrapperOpacity", _8 as "wrapper_closed", _9 as "wrapperOff", _a as "container", _b as "header", _c as "modal_title", _d as "close", _e as "container_noPadding", _f as "container_scrollable" }
export default { "__esModule": _1, "iphone5": _2, "mobile": _3, "tablet": _4, "mainWrapper": _5, "wrapper": _6, "wrapperOpacity": _7, "wrapper_closed": _8, "wrapperOff": _9, "container": _a, "header": _b, "modal_title": _c, "close": _d, "container_noPadding": _e, "container_scrollable": _f }
